export function newBlockVisitor(driver, revision) {
    return {
        get revision() { return revision; },
        get: () => driver.getBlock(revision)
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmxvY2stdmlzaXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9ibG9jay12aXNpdG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sVUFBVSxlQUFlLENBQzNCLE1BQXFCLEVBQ3JCLFFBQXlCO0lBR3pCLE9BQU87UUFDSCxJQUFJLFFBQVEsS0FBSyxPQUFPLFFBQVEsQ0FBQSxDQUFDLENBQUM7UUFDbEMsR0FBRyxFQUFFLEdBQUcsRUFBRSxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsUUFBUSxDQUFDO0tBQ3ZDLENBQUE7QUFDTCxDQUFDIn0=